
import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export class IconSearch extends Vue {
  @Prop({ default: 26 }) public size!: number;
  @Prop({ default: "#000" }) public color!: string;
}
export default IconSearch;
